import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';

import { ApiResponse } from './daily-rewards.entity';

@Injectable({
  providedIn: 'root'
})
export class DailyRewardsService extends AbstractService {
  protected override prefix = '/bonuses';

  getRewards(): Observable<ApiResponse.RewardsList> {
    return this.get<ApiResponse.RewardsList>('/daily-rewards/list');
  }

  checkSteamPhoto(): Observable<ApiResponse.CheckSteamPhoto> {
    return this.post<ApiResponse.CheckSteamPhoto>('/avatars/check-steam-photo', { }, { throwError: true });
  }

  takeReward(id: number): Observable<ApiResponse.TakenReward> {
    return this.post<ApiResponse.TakenReward>(`/daily-rewards/rewards/${ id }/take`, { }, { throwError: true });
  }
}